import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { history } from "../history";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar
} from '@material-ui/core';

import Cookies from 'universal-cookie';
import { alert } from '../utilities';
const cookies = new Cookies();

const useStyles = makeStyles(theme => ({
  media: {
    padding: '10px',
    height: 80,
    width: 80,
  },
  CardContent: {
    padding: '14px 0px',
    "&:last-child": {
      // padding: '0'
    },
  },
  card: {
    boxShadow: "0px 2px 5px rgba(83, 97, 255, 0.0534986)",
    borderRadius: "8px",
    '&:hover': {
      boxShadow: "4px 8px 20px 0 rgba(0, 0, 0, 0.5), 4px 8px 20px 0 rgba(0, 0, 0, 0.5)"
    }
  },
  topDiv: {
    padding: '1rem 0',
    paddingBottom: '0px'
  },
  productTitle: {
    textDecoration: 'none',
    padding: '1rem',
    paddingTop: '0px',
    textAlign: 'center',
    color: '#1e293b',
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0.5px',
    fontFamily: 'century_gothic',
  },
  subTitle: {
    color: '#ffffff',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '4rem',
    [theme.breakpoints.down('xs')]: {
      textAlign: "center",
    },
  }
}));

const ProductCard = props => {
  const { product } = props;
  const classes = useStyles();
  var ovCid = cookies.get('ovCid')

  const productModalToggle = (href) => {
    if (ovCid.toString() !== "624e80fff8ee75131034af66") {
      history.push(href)
    }
  }
  const alertModal = (href) => {
    alert.comingSoon("Coming Soon")
  }

  return (
    // <Link
    //   style={{
    //     pointerEvents: ovCid.toString() === "624e80fff8ee75131034af66" ? "none" : "initial",
    //     textDecoration: 'none'
    //   }}
    //   to={product.href}>
    <Card
      style={{
        opacity: ovCid.toString() === "624e80fff8ee75131034af66" ? 0.5 : 1,
        backgroundColor: "white",
        cursor: "pointer",
        textDecoration: 'none'
      }}
      className={classes.card}
      onClick={() => {
        if (product.href === "/chat/") {
          alertModal()
        }
        else {
          if (product._id == "66b0bef00a93a24eadf8951d") {
            productModalToggle(window.innerWidth >= 768 ? "/elearning/dashboard" : "/elearning/knowledgebase")
          }
          else if (product._id == "68359335d745aea7674251cb" || product._id == "6814babe46a7420836dd5ba6") {
            productModalToggle("/news-app")
          }
          else if (product._id == "6835aa57d745aea7674456ef" || product._id == "6810cbc4418a1030d6ee2075") {
            productModalToggle(window.innerWidth >= 768 ? "/scheduler/dashboard" : "/scheduler/dashboard")
          }
          else if (product._id == "6835b49ad745aea76745dc84" || product._id == "678e156a769f35d0f595a5f5") {
            productModalToggle(window.innerWidth >= 768 ? "/hr/hierarachy_chart" : "/hr/users")
          }
          else if (product._id == "6835afe9d745aea767454b40" || product._id == "6852c5eff23f0769947c5eb9") {
            productModalToggle("/analytics/all/location")
          }
          else if (product._id == "6960c77b62fd45995ce14e1f" || product._id == "6960dceb485f4c1c10ad1688") {
            // productModalToggle("/teamfeedback/dashboard")
            productModalToggle("/team-feedback");
          }
          // productModalToggle(product.href);
        }
      }}
    >
      <CardContent className={classes.CardContent} >
        <Grid
          className={classes.topDiv}
          container
          spacing={0}
        >
          <Grid
            item
            sm={12}
            xs={12}
            style={{
              padding: "1px",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Avatar
              style={{ backgroundColor: "white" }}
              className={classes.media}
              src={product?.product_desktop_logo}
            />
          </Grid>
          {/* <Grid
              item
              sm={8}
              xs={12}
            >
              <Typography
                className={classes.subTitle}
              >
                Started sending atss
              </Typography>
            </Grid> */}

        </Grid>
        {/* <Divider
            style={{ color: "#ffffff" }}
          /> */}

        <Typography
          className={classes.productTitle}
        >
          {product?.product_title}
        </Typography>
      </CardContent>
    </Card>
    // </Link >
  );
};

export default ProductCard;
